export default __webpack_public_path__ + "assets/raw-js/draco_wasm_wrapper-4b0c8c0ea71064b90052980fc59ea24d.js";